const s = {
  root: { minHeight: '100vh', background: '#050505', color: '#fff', padding: '0 20px', fontFamily: "'Euclid Circular B', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif", WebkitFontSmoothing: 'antialiased' },
  inner: { maxWidth: 760, margin: '0 auto' },
  back: { display: 'inline-block', padding: '20px 0 12px', color: 'rgba(255,255,255,.5)', textDecoration: 'none', fontSize: 14, transition: 'color .15s' },
  h1: { fontSize: 36, fontWeight: 800, letterSpacing: '-0.03em', margin: '0 0 8px' },
  meta: { color: 'rgba(255,255,255,.45)', fontSize: 14, marginBottom: 48 },
  h2: { fontSize: 20, fontWeight: 700, letterSpacing: '-0.02em', margin: '40px 0 12px', color: '#fff' },
  p: { color: 'rgba(255,255,255,.7)', fontSize: 15, lineHeight: 1.7, margin: '0 0 16px' },
  ul: { color: 'rgba(255,255,255,.7)', fontSize: 15, lineHeight: 1.7, margin: '0 0 16px', paddingLeft: 24 },
  li: { marginBottom: 6 },
  a: { color: '#FF7E67', textDecoration: 'none' },
};

export default function PrivacyScreen() {
  return (
    <div style={s.root}>
      <div style={s.inner}>
        <a href="/" style={s.back}>← Back to Flux URO</a>
      </div>
      <div style={{ ...s.inner, paddingBottom: 80 }}>
        <h1 style={s.h1}>Privacy Policy</h1>
        <p style={s.meta}>Effective Date: June 2026 · Flux Uro FZ-LLC · United Arab Emirates</p>

        <h2 style={s.h2}>1. Introduction</h2>
        <p style={s.p}>
          Flux URO respects your privacy and is committed to protecting your personal data. This Privacy Policy describes how we collect, use, disclose, and safeguard your information when you use our website, services, or platform. By accessing our platform, you consent to this Privacy Policy.
        </p>

        <h2 style={s.h2}>2. What Data We Collect</h2>
        <p style={s.p}>We collect the following types of data:</p>
        <ul style={s.ul}>
          <li style={s.li}><strong style={{ color: '#fff' }}>Account Information:</strong> Name, email address, business address, phone number, job title.</li>
          <li style={s.li}><strong style={{ color: '#fff' }}>Billing Information:</strong> Payment details processed via Stripe. We do not store credit card numbers.</li>
          <li style={s.li}><strong style={{ color: '#fff' }}>Technical Data:</strong> IP address, browser type, operating system, device ID, time zone, referral URLs.</li>
          <li style={s.li}><strong style={{ color: '#fff' }}>Usage Data:</strong> Page views, API request logs, generation inputs and outputs, error reports, generation history.</li>
          <li style={s.li}><strong style={{ color: '#fff' }}>Credit & Transaction Data:</strong> URO credit balances, top-up history, and spend per model.</li>
        </ul>

        <h2 style={s.h2}>3. How We Use Your Data</h2>
        <ul style={s.ul}>
          <li style={s.li}>To provide and maintain the services</li>
          <li style={s.li}>To process payments and manage credits</li>
          <li style={s.li}>To communicate updates, support responses, and promotions (if opted in)</li>
          <li style={s.li}>To improve service reliability and user experience</li>
          <li style={s.li}>For security, fraud detection, and legal compliance</li>
          <li style={s.li}>For aggregated, anonymized analytics on platform performance</li>
        </ul>

        <h2 style={s.h2}>4. Data Sharing</h2>
        <p style={s.p}>We may share your data with:</p>
        <ul style={s.ul}>
          <li style={s.li}><strong style={{ color: '#fff' }}>Stripe</strong> — for payment processing</li>
          <li style={s.li}><strong style={{ color: '#fff' }}>Cloud hosting providers</strong> — e.g., DigitalOcean, AWS (infrastructure only)</li>
          <li style={s.li}><strong style={{ color: '#fff' }}>AI inference providers</strong> — e.g., Google, OpenAI (your prompts are forwarded to generate outputs)</li>
          <li style={s.li}><strong style={{ color: '#fff' }}>Legal and regulatory authorities</strong> — when required by law</li>
        </ul>
        <p style={s.p}>We do not sell or rent your personal data to any third party.</p>

        <h2 style={s.h2}>5. Data Retention</h2>
        <p style={s.p}>
          We retain user data for the duration of the account and up to 12 months after termination, unless a longer period is required by UAE law. Generation inputs and outputs are stored for 30 days for support and analytics purposes. You may request earlier deletion at any time.
        </p>

        <h2 style={s.h2}>6. Your Rights</h2>
        <p style={s.p}>Subject to UAE data protection laws (Federal Decree-Law No. 45 of 2021), you may:</p>
        <ul style={s.ul}>
          <li style={s.li}>Access your personal data</li>
          <li style={s.li}>Request correction or deletion of your data</li>
          <li style={s.li}>Request a portable copy of your data</li>
          <li style={s.li}>Withdraw consent to marketing communications</li>
          <li style={s.li}>Lodge a complaint with the UAE Data Office</li>
        </ul>
        <p style={s.p}>
          To exercise any of these rights, contact us at{' '}
          <a href="mailto:support@fluxuro.ai" style={s.a}>support@fluxuro.ai</a>.
        </p>

        <h2 style={s.h2}>7. International Data Transfers</h2>
        <p style={s.p}>
          While we operate from the UAE, our infrastructure may involve cross-border transfers such as backups or CDN caching. We ensure all data handling complies with UAE's Data Protection Law (Federal Decree-Law No. 45 of 2021).
        </p>

        <h2 style={s.h2}>8. Cookie Policy</h2>
        <p style={s.p}>
          We use cookies to improve your user experience, maintain sessions, and collect analytics. You may disable cookies via your browser settings, but doing so may affect platform functionality. We do not use cookies to track you across third-party websites.
        </p>

        <h2 style={s.h2}>9. Minors</h2>
        <p style={s.p}>
          Our platform is not intended for users under 18 years of age. We do not knowingly collect personal data from minors. If you believe a minor has provided us with data, please contact us immediately.
        </p>

        <h2 style={s.h2}>10. Updates to This Policy</h2>
        <p style={s.p}>
          We may update this Privacy Policy periodically. Users will be notified of significant changes via email or platform notification. Continued use after an update constitutes acceptance of the revised policy.
        </p>

        <div style={{ marginTop: 48, padding: '24px', borderRadius: 16, border: '1px solid rgba(255,255,255,.08)', background: 'rgba(255,255,255,.03)' }}>
          <p style={{ ...s.p, margin: 0 }}>
            Questions about your privacy? Contact us at{' '}
            <a href="mailto:support@fluxuro.ai" style={s.a}>support@fluxuro.ai</a>
            {' '}or join our{' '}
            <a href="https://discord.gg/4b6S849Y2t" style={s.a} target="_blank" rel="noopener noreferrer">Discord</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
